import { render, staticRenderFns } from "./OrderWorklogs.vue?vue&type=template&id=e4e340fa&"
import script from "./OrderWorklogs.vue?vue&type=script&lang=ts&"
export * from "./OrderWorklogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports